import React from "react";
import Navbar from "../Home/Navbar";

export default function Cancel() {
  return (
    <>
      <Navbar />
      <div>You have cancelled the payment</div>
    </>
  );
}
